import { Col, Row, Image, Button, Modal, Form, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import ListGroup from "../component/ListGroup";
import TableComp from "../component/Table";
import { useCallback, useEffect, useState } from "react";
// import { StarDots } from "../component/ActionRow";
import { HiPhone } from "react-icons/hi2";
import { TiLocation } from "react-icons/ti";
import LinkDriverList from "../component/LinkDriverList";
import GoalAchievedCard from "../component/GoalAchievedCard";
import Filter from "../component/Filter";
import NavLink from "../component/NavLink";
import { useLocation, useNavigate } from "react-router-dom";
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import Pagination from "react-responsive-pagination";
import ReactLoading from "react-loading";
import "react-responsive-pagination/themes/classic.css";
import SessionUtil from "../util/SessionUtil";
import Banner from "../component/Banner";
import CalendarComp from "../component/CalendarComp";
import { TbLocationFilled } from "react-icons/tb";
import { FiLink } from "react-icons/fi";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css"; // مهم جداً
import { ActionRow } from "../component/ActionRow";
import Swal from "sweetalert2";
import { MdEdit } from "react-icons/md";

const CustomRow = ({
  rowData,
  columnNames,
  handleClickRow,
  handleTracking,
  page,
  handleClickAction,
}) => {
  const { t } = useTranslation();
  const lang = SessionUtil.getLang();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <tr>
      {columnNames.map((columnName, index) => (
        <td
          onClick={() =>
            page === "live-driver-list" &&
            handleClickRow("driver", rowData.Id, rowData)
          }
          key={index}
          className="cursor-pointer"
        >
          {columnName === "DriverId" ? (
            <span>#{rowData.Id}</span>
          ) : columnName === "DriverName" ? (
            <div className="flex-gap-2 flex-gap-2">
              {rowData?.DriverImage ? (
                <div className="dimension-40">
                  <Image
                    alt="image"
                    src={rowData.DriverImage}
                    className="img-fluid cursor-pointer"
                    onClick={() => setIsOpen(true)}
                  />
                  {isOpen && (
                    <Lightbox
                      mainSrc={rowData.DriverImage}
                      onCloseRequest={() => setIsOpen(false)}
                    />
                  )}
                </div>
              ) : (
                <span className="img-empty"></span>
              )}
              <p className="mb-0">
                {lang === "en" || rowData.DriverNameAr === null
                  ? rowData?.DriverNameEn
                  : rowData?.DriverNameAr}
              </p>
            </div>
          ) : columnName === "DriverPhone" ? (
            <div className="flex-gap-2">
              <HiPhone size={16} color={"#3A974C"} />{" "}
              <p className="mb-0">
                {"+" + rowData.AreaCode + "" + rowData.PhoneNumber}
              </p>
            </div>
          ) : columnName === "DriverAddress" ? (
            <div className="flex-gap-2">
              <TiLocation size={16} color="#4285F4" />
              <p className="mb-0">{rowData.Address}</p>{" "}
            </div>
          ) : columnName === "Link with Operation" ? (
            <div className="flex-gap-2">
              <FiLink size={20} className="rotate-45" />
              <p className="mb-0">
                {rowData?.OperationName ? rowData.OperationName : "--"}
              </p>{" "}
            </div>
          ) : columnName === "Status" ? (
            rowData.PaymentStatus === null ? (
              "--"
            ) : rowData.PaymentStatus === "PAID" ? (
              <div className="status status-success">
                <p className="mb-0">{t("Paid")}</p>
              </div>
            ) : (
              <div className="status status-failed">
                <p className="mb-0">{t("Not Paid")}</p>
              </div>
            )
          ) : columnName === "Action" ? (
            <div className="flex-gap-2">
              <Button
                className="btn-danger font-12"
                disabled={rowData.Banned === 1}
                onClick={() => handleClickAction("isPause", true, rowData.Id)}
              >
                {t("Ban")}
              </Button>
              <Button
                className="btn-dark font-12"
                onClick={() =>
                  handleClickAction(
                    "isBlock",
                    rowData.Blocked === 0,
                    rowData.Id
                  )
                }
              >
                {rowData.Blocked === 0 ? t("Block") : t("Unblock")}
              </Button>
            </div>
          ) : (
            <p className="mb-0">{rowData[columnName]}</p>
          )}
        </td>
      ))}
      {page === "driver-list" && (
        <td>
          <ActionRow
            id={rowData.Id}
            page="driver"
            handleClickRow={handleClickRow}
            data={rowData}
          />
        </td>
      )}
      {page === "live-driver-list" && (
        <td className="separate-column cursor-pointer">
          <div onClick={() => handleTracking(rowData)} className="flex-gap-2">
            <TbLocationFilled size={16} color="#F2953C" />
            {t("Track")}
          </div>
        </td>
      )}
    </tr>
  );
};

const DriverList = ({ page }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const [showOffcanvas, setShowOffcanvas] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordCount, setRecordCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const isLoggedIn = SessionUtil.isLoggedIn(); // Custom hook or context
  const columnNames = [
    "DriverId",
    "DriverName",
    "DriverPhone",
    "DriverAddress",
    "Status",
    "Action",
  ];
  const columnNamesLiveDriver = [
    "DriverId",
    "DriverName",
    "DriverPhone",
    "DriverAddress",
    "Link with Operation",
    "Status",
  ];
  const [sortedData, setSortedData] = useState([]);
  const [dateActive, setDateActive] = useState();
  const typeUser = SessionUtil.getTypeUser();
  const [filter, setFilter] = useState("");
  const [percentage, setPercentage] = useState();
  const [show, setShow] = useState(false);
  const [price, setPrice] = useState("");
  const [validated, setValidated] = useState(false);
  const [state, setState] = useState([]);
  const [stateId, setStateId] = useState("");
  const [stateName, setStateName] = useState("");
  const [country, setCountry] = useState("");
  const [msgError, setMsgError] = useState("");
  const handleClose = () => {
    setShow(false);
    setPrice("");
    setValidated(false);
    setLoadingSubmit(false);
  };
  const handleShow = () => setShow(true);
  const handleFilter = (filter, country, type, stateId, stateName) => {
    setFilter(filter);
    setCountry(country);
    setStateId(stateId);
    setStateName(stateName);
    type !== "country" ? getDriverApi(filter, stateId) : getDriverApi(filter);
    document.body.classList.remove("bg-offcanvas");
    setShowOffcanvas(true);
  };

  const handleClickRow = (type, id, data) => {
    navigate(`/Orders/${type}/${id}`, {
      state: {
        id: id,
        type: type,
        data: data,
      },
    });
  };
  const getDriverApi = useCallback(
    async (filter, stateId) => {
      // setLoading(true);
      let params = {
        PageNumber: currentPage,
        PageSize: "10",
        OrderBy: "Id Desc",
        DriversView:
          page === "driver-list"
            ? {
                CreatedDate: dateActive,
                PaymentStatus: filter,
                StateId: stateId,
                StatusCode: "ACTIVE",
              }
            : {
                IsOnline: 1,
                PaymentStatus: filter,
                StateId: stateId,
                StatusCode: "ACTIVE",
              },
      };

      const res = await ApiUtil.postApi(
        ApiPath.GET_ALL_DRIVERS,
        params,
        "POST"
      );
      if (res.IsSuccessfull) {
        const totalPage = Math.ceil(res.Result.RecordCount / 10);
        setSortedData(res.Result.Driver);
        setRecordCount(totalPage);
        setLoading(false);
      }
    },
    [currentPage, page, dateActive]
  );
  const deliveryCommissionPercentage = async () => {
    const res = await ApiUtil.getApi(ApiPath.DELIVERY_COMMISSION_PERCE, "GET");

    if (res.IsSuccessfull) {
      setPercentage(res.Result.Value);
    }
  };

  useEffect(() => {
    if (isLoggedIn) {
      getDriverApi();
      if (location) {
        setCountry("");
        setFilter("");
        setStateId("");
        setStateName("");
      }
    }
  }, [location, isLoggedIn, getDriverApi]);
  useEffect(() => {
    if (isLoggedIn) {
      deliveryCommissionPercentage();
    }
  }, [isLoggedIn]);
  const handlePageNumber = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleReload = () => {
    setFilter();
    setCountry();
    setDateActive();
    getDriverApi();
  };

  const handleTracking = (data) => {
    navigate(`/tracking-driver/${data.Id}`, {
      state: {
        id: data.Id,
        page: "live-driver-list",
      },
    });
  };
  const handleClickAction = (type, isClick, id) => {
    if (type === "isPause") {
      Swal.fire({
        title: t("Are you sure you want to ban the user?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("Yes, ban!"),
        cancelButtonText: t("Cancel"),
        customClass: {
          title: "font-16",
          confirmButton: "font-14",
          cancelButton: "font-14",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          handleClickBan(isClick, id); // بإمكانك تغيير اسم الدالة لاحقًا لـ handleClickBan إذا أردت
          Swal.fire({
            title: t("Banned!"),
            text: t("The user has been successfully banned."),
            icon: "success",
            customClass: {
              title: "font-16",
              confirmButton: "font-14",
            },
          });
        }
      });
    } else {
      Swal.fire({
        title: isClick
          ? t("Are you sure you want to block the user?")
          : t("Are you sure you want to unblock the user?"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: isClick ? t("Yes, block!") : t("Yes, unblock!"),
        cancelButtonText: t("Cancel"),
        customClass: {
          title: "font-16",
          confirmButton: "font-14",
          cancelButton: "font-14",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          handleClickBlock(isClick, id);
          Swal.fire({
            title: isClick ? t("Blocked!") : t("Unblocked!"),
            text: isClick
              ? t("The user has been successfully blocked.")
              : t("The user has been successfully unblocked."),
            icon: "success",
            customClass: {
              title: "font-16",
              confirmButton: "font-14",
            },
          });
        }
      });
    }
  };
  const handleClickBlock = async (block, id) => {
    const params = {
      Block: block,
      DriverId: id,
    };

    await ApiUtil.postApi(ApiPath.BLOCK, params, "POST");

    // ✅ تحديث الـ sortedData محليًا:
    setSortedData((prevData) =>
      prevData.map((item) =>
        item.Id === id ? { ...item, Blocked: block ? 1 : 0 } : item
      )
    );
  };
  const handleClickBan = async (ban, id) => {
    const params = {
      Ban: ban,
      DriverId: id,
    };

    await ApiUtil.postApi(ApiPath.BAN, params, "POST");

    //if (res.message === "Driver already banned.") {
    // ✅ تحديث الـ sortedData محليًا:
    setSortedData((prevData) =>
      prevData.map((item) => (item.Id === id ? { ...item, Banned: 1 } : item))
    );
    //}
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    if (price) {
      updatePercentage();
    }
  };
  const updatePercentage = async () => {
    setLoadingSubmit(true);
    let params = {
      Variable: "delivery_commission_percentage",
      Value: price,
    };

    const res = await ApiUtil.postApi(
      ApiPath.GATEWAYWEB_SETTINGS,
      params,
      "POST"
    );
    if (res.IsSuccessfull) {
      setLoadingSubmit(false);

      handleClose();
      deliveryCommissionPercentage();
      Swal.fire({
        icon: "success",
        title: t("Updated successfully"),
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          title: "font-16",
        },
      });
    } else {
      setMsgError(res.Message);
      setLoadingSubmit(false);
    }
  };
  const getLocationApi = useCallback(async () => {
    const areaCode = country ? country : "962";
    const res = await ApiUtil.getApi(
      ApiPath.LOCATION + "?AreaCode=" + areaCode
    );
    if (res.IsSuccessfull) {
      setState(res.Result);
    }
  }, [country]);
  useEffect(() => {
    getLocationApi();
  }, [getLocationApi]);
  return (
    <>
      <Row className="g-0">
        {!loading ? (
          <>
            <Col lg={8} className="position-relative">
              <ListGroup />
              {page === "driver-list" && (
                <>
                  <Banner />
                  <CalendarComp setDateActive={setDateActive} />
                </>
              )}

              <div className=" mt-4 d-flex justify-content-between gap-2">
                <p className="title">
                  {page === "driver-list"
                    ? t("Driver List")
                    : t("Live Driver List")}
                </p>
                <div className="flex-gap-2">
                  <Button className="font-13 btn-orange" onClick={handleReload}>
                    {page === "live-driver-list" ? t("Update") : t("View All")}
                  </Button>
                  <Filter
                    showOffcanvas={showOffcanvas}
                    setShowOffcanvas={setShowOffcanvas}
                    handleClick={handleFilter}
                    country={country}
                    stateId={stateId}
                    filter={filter}
                  />
                  <Filter
                    type={"country"}
                    showOffcanvas={showOffcanvas}
                    setShowOffcanvas={setShowOffcanvas}
                    handleClick={handleFilter}
                    filter={filter}
                    country={country}
                  />
                  <Filter
                    type={"state"}
                    showOffcanvas={showOffcanvas}
                    setShowOffcanvas={setShowOffcanvas}
                    handleClick={handleFilter}
                    filter={filter}
                    data={state}
                    stateId={stateId}
                    stateName={stateName}
                    country={country}
                  />
                </div>
              </div>
              <div className="flex-gap-2">
                <p className="mb-0 fw-bold">
                  {t("Profit percentage per driver")} :{" "}
                </p>
                <div className="flex-gap-2">
                  <p className="mb-0 fw-bold">{percentage}</p>
                  <MdEdit
                    className="cursor-pointer"
                    onClick={handleShow}
                    color="#0077b6"
                    title={t("Update")}
                    size="22"
                  />
                </div>
              </div>
              <TableComp
                data={sortedData}
                columnNames={
                  page === "driver-list" ? columnNames : columnNamesLiveDriver
                }
                setSortedData={setSortedData}
                track={page === "live-driver-list"}
                //  handleSelectAll={handleSelectAll} isChecked={isCheckAll} handleDelete={handleDelete}
              >
                {sortedData.map((rowData, index) => (
                  <CustomRow
                    key={index}
                    rowData={rowData}
                    handleClickAction={handleClickAction}
                    columnNames={
                      page === "driver-list"
                        ? columnNames
                        : columnNamesLiveDriver
                    }
                    //  handleClick={handleCheckbox} isChecked={isCheck.includes(rowData.Id)} handleStar={handleStar}
                    handleClickRow={handleClickRow}
                    handleTracking={handleTracking}
                    page={page}
                  />
                ))}
              </TableComp>
              <Pagination
                current={currentPage}
                total={recordCount}
                onPageChange={(pageNumber) => handlePageNumber(pageNumber)}
                extraClassName="justify-content-end"
              />
            </Col>

            <Col md={1}>
              <div className="divider-vertical mx-auto"></div>
            </Col>
            <Col lg={3} className="mt-5">
              <NavLink />
              <LinkDriverList
                title={t("Top Driver")}
                subtitle={t("Keep up to be TOP")}
                data={[]}
                page="driver"
              />
              {typeUser === "4" && (
                <GoalAchievedCard
                  title={"Robert Bacins"}
                  page="driver"
                  // data={goalData}
                  percentageTop={60}
                />
              )}
            </Col>
          </>
        ) : (
          <Col lg={12} className="loading-style">
            <ReactLoading
              type={"bars"}
              color={"#c8c8c8"}
              height={"50px"}
              width={"50px"}
            />
          </Col>
        )}
      </Row>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="font-16">
            {t("Update") + " " + t("Profit percentage per driver")}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formGroupPrice">
              <Form.Label className="font-SemiBold">{t("Price")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={`${t("Enter")} ${t("Price")}`}
                value={price}
                inputMode="decimal"
                pattern="^\d*\.?\d*$"
                onBeforeInput={(e) => {
                  const inputChar = e.data;
                  if (
                    inputChar &&
                    (!/[\d.]/.test(inputChar) ||
                      (inputChar === "." && price.includes(".")))
                  ) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => setPrice(e.target.value)}
                required
              />

              <Form.Control.Feedback type="invalid">
                {t("Please enter") + " " + t("Price")}
              </Form.Control.Feedback>
            </Form.Group>
            {msgError && (
              <Alert variant="danger" className="mt-3">
                {msgError}
              </Alert>
            )}
            <div className="d-flex justify-content-end mt-3">
              <Button
                aria-label="Aria label"
                type="submit"
                className="btn-main"
                disabled={loadingSubmit}
              >
                <div className="flex-gap-2 justify-content-center">
                  {t("Save")}
                  {loadingSubmit && (
                    <ReactLoading
                      type={"spin"}
                      color={"#c8c8c8"}
                      height={"20px"}
                      width={"20px"}
                    />
                  )}
                </div>
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DriverList;
